<script lang="ts">
  import googleCookies from "./googleCookies";

  let {
    class: classes,
  }: {
    class?: string;
  } = $props();
</script>

<details class={classes}>
  <summary>
    <strong>Google-informasjonskapsler for markedsføring.</strong> Hvis du har godtatt cookies for markedsføring
    på dette nettstedet brukes det informasjonskapsler fra Google.
  </summary>

  <p>
    Hvis du har godtatt cookies for markedsføring på dette nettstedet kjører det datakode fra <a
      href="https://developers.google.com/tag-platform/tag-manager"
      target="_blank"
      hreflang="en">Google Tag Manager</a
    >, som igjen bruker informasjonskapsler fra Google. Ishavskraft bruker Google Tag Manager for å
    analysere Ishavskraft sin Google-relaterte markedsføring og for å kunne tilpasse markedsføringen
    vår.
  </p>

  <p>
    Ishavskraft AS tar forbehold om at Google kan endre informasjonskapslene som brukes og vi
    oppdaterer ved aktuelle endringer. <em
      >Kilden er
      <a href="https://business.safety.google/adscookies/" hreflang="en" target="_blank"
        >Googles detaljerte liste over mulige cookies</a
      ></em
    >.
  </p>

  <table>
    <!-- navn, varighet, beskrivelse -->
    <thead><tr> <th>Navn</th> <th>Type</th> <th>Varighet</th> </tr></thead>
    <tbody lang="en">
      <!-- eslint-disable-next-line svelte/require-each-key -->
      {#each googleCookies as { name, lifespan: duration }}
        <tr> <td>{name}</td> <td>Cookie</td> <td>{duration}</td> </tr>
      {/each}
    </tbody>
  </table>
</details>
